import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import { FormFieldLine } from '../../../../../../../components/form-field-line/form-field-line';
import { Input } from '../../../../../../../components/inputs/input/input';
import DhlCredentialsStore from "../../../../stores/credentials/shipping/dhl-credentials-store";

interface IProps {
    credentialsStore: DhlCredentialsStore,
    vGroup: IValidationGroup,
}

const DhlCredentials: React.FC<IProps> = observer(({
                                                             credentialsStore,
                                                             vGroup,
                                                         }) => {
    return (
        <>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label='MyDhl API Key'
                note='Your MyDHL API Key'
            />
            <FormFieldLine
                required
                label='MyDHL API secret'
                key='api_secret'
                note='Your MyDhl API secret'
            >
                <Input
                    value={credentialsStore.apiSecret}
                    onChange={credentialsStore.setApiSecret}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                required
                label='DHL Account number'
                key='customer_number'
                note='Your international DHL Account number'
            >
                <Input
                    value={credentialsStore.customerNumber}
                    onChange={credentialsStore.setCustomerNumber}
                    validationGroup={vGroup}
                    required
                />
            </FormFieldLine>
            <FormFieldLine
                label='VAT number'
                key='vat_number'
                note='Your VAT number to include on the invoice'
            >
                <Input
                    value={credentialsStore.vatNumber}
                    onChange={credentialsStore.setVatNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label='EORI number'
                key='eori_number'
                note='Your EORI number to include on the invoice'
            >
                <Input
                    value={credentialsStore.eoriNumber}
                    onChange={credentialsStore.setEoriNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
            <FormFieldLine
                label='Duties and Taxes account number'
                key='duties_taxes_account_number'
                note='Shipping Account Number for Customs Duties'
            >
                <Input
                    value={credentialsStore.dutiesTaxesAccountNumber}
                    onChange={credentialsStore.setDutiesTaxesAccountNumber}
                    validationGroup={vGroup}
                />
            </FormFieldLine>
        </>
    );
});

export default DhlCredentials;
